export const UPDATE_CURRENT_LANGUAGE = 'UPDATE_CURRENT_LANGUAGE';

export default function updateCurrentLanguage(locale) {
    return dispatch => {
        dispatch({
            type: UPDATE_CURRENT_LANGUAGE,
            payload: locale
        });
    }
}